import type { SvelteComponent } from "svelte"
import Columns from "./Columns.svelte"
import HeroSlider from "./HeroSlider.svelte"
import ContentSlider from "./ContentSlider.svelte"
import ThumbnailSlider from "./ThumbnailSlider.svelte"
import HeroImage from "./HeroImage.svelte"
import HowItWorksSlider from "./HowItWorksSlider.svelte"
import ContentCards from "./ContentCards.svelte"
import Team from "./Team.svelte"
import NewsTeaser from "./NewsTeaser.svelte"
import Partners from "./Partners.svelte"
import Products from "./Products.svelte"
import ContactForm from "./ContactForm.svelte"
import ProductEyecatcher from "./ProductEyecatcher.svelte"
import NewsArchive from "./NewsArchive.svelte"
import JobList from "./JobList.svelte"
import PredefinedBlock from "./PredefinedBlock.svelte"
import Retailers from "./Retailers.svelte"
import BatteryCheck from "./BatteryCheck.svelte"
import BatteryServiceForm from "./BatteryServiceForm.svelte"
import RaffleForm from "./RaffleForm.svelte"

const blocks: {
    [key: string]: {
        sectionClass: string
        component: typeof SvelteComponent<{ block?: ContentBlockEntry; apiBase?: string }>
    }
} = {
    default: {
        sectionClass: "",
        component: Columns,
    },
    columns: {
        sectionClass: "",
        component: Columns,
    },
    heroImage: {
        sectionClass: "",
        component: HeroImage,
    },
    heroSlider: {
        sectionClass: "hero",
        component: HeroSlider,
    },
    thumbnailSlider: {
        sectionClass: "hero",
        component: ThumbnailSlider,
    },
    contentSlider: {
        sectionClass: "content-slider",
        component: ContentSlider,
    },
    newsTeaser: {
        sectionClass: "news",
        component: NewsTeaser,
    },
    newsArchive: {
        sectionClass: "",
        component: NewsArchive,
    },
    howItWorksSlider: {
        sectionClass: "",
        component: HowItWorksSlider,
    },
    contentCards: {
        sectionClass: "",
        component: ContentCards,
    },
    team: {
        sectionClass: "",
        component: Team,
    },
    partners: {
        sectionClass: "",
        component: Partners,
    },
    products: {
        sectionClass: "",
        component: Products,
    },
    productEyecatcher: {
        sectionClass: "hardware-rows",
        component: ProductEyecatcher,
    },
    contactForm: {
        sectionClass: "",
        component: ContactForm,
    },
    raffleForm: {
        sectionClass: "",
        component: RaffleForm,
    },
    jobList: {
        sectionClass: "",
        component: JobList,
    },
    retailers: {
        sectionClass: "",
        component: Retailers,
    },
    batteryCheck: {
        sectionClass: "",
        component: BatteryCheck,
    },
    batteryServiceForm: {
        sectionClass: "",
        component: BatteryServiceForm,
    },
    predefinedBlock: {
        sectionClass: "predefined-block",
        component: PredefinedBlock,
    },
}

export default blocks
